import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.scss";

import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // basename MUST stay "/". The app is served under /admin/ on nginx, but every
  // in-app route already carries the /admin prefix (App.jsx `admin/*`, routes.js
  // `layout: "/admin"`, sidebar `to="/admin/..."`, etc.). Deriving basename from
  // PUBLIC_URL (which is "/admin" for the subpath asset build) makes the router
  // ALSO prepend /admin, so every link doubles to /admin/admin/... . Keep
  // PUBLIC_URL=/admin for asset paths only; the router prefix comes from the routes.
  <BrowserRouter basename="/">
    <App />
  </BrowserRouter>
);
